import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { RouteErrorScreen } from "./components/RouteErrorScreen/RouteErrorScreen";
import { RoutePendingScreen } from "./components/RoutePendingScreen/RoutePendingScreen";

export const router = createRouter({
  routeTree,
  // Styled fallback for any error thrown by a route loader/component that isn't
  // handled locally — replaces TanStack Router's raw default error dump.
  defaultErrorComponent: RouteErrorScreen,
  // Never retain an outgoing project/dashboard while the next code-split
  // route resolves. Besides being misleading, that can briefly paint one
  // brand's content under another project's URL.
  defaultPendingComponent: RoutePendingScreen,
  defaultPendingMs: 0,
  defaultPendingMinMs: 200,
});

declare global {
  interface Window {
    __juiceVisualRouter?: typeof router;
  }
}

if (import.meta.env.VITE_USE_MOCKS === "1" && typeof window !== "undefined") {
  window.__juiceVisualRouter = router;
}

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
